import React from 'react';
import { ArcTableHeadProps } from './types';
import { TableHead } from '@mui/material';

const ArcTableHead: React.FC<ArcTableHeadProps> = (props) => {
  return <TableHead {...props} />;
};

export default ArcTableHead;